import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Voltage from "../axes/Voltage";
import Percentage from "../axes/Percentage";

let SoilStickMoisture2Vwc = {
    type: "line",
    label: "Soil Moisture 2 (%)",
    fill: true,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Percentage,
    xAxis:Time
};

export default SoilStickMoisture2Vwc;



// WEBPACK FOOTER //
// ./src/components/chart/channels/SoilStickMoisture2Vwc.js